"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _card = _interopRequireDefault(require("./card.container"));

var _Actions = _interopRequireDefault(require("./Actions"));

var _Content = _interopRequireDefault(require("./Content"));

var _Header = _interopRequireDefault(require("./Header"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = Object.assign(_card["default"], {
  Actions: _Actions["default"],
  Content: _Content["default"],
  Header: _Header["default"]
});

exports["default"] = _default;